import * as runtypes from 'runtypes';

export const InstitutionHealth = runtypes.Record({
  successRate: runtypes.Number,
  date: runtypes.InstanceOf(Date)
});

export type InstitutionHealth = runtypes.Static<typeof InstitutionHealth>;
